import React from 'react';
import { useNavigate } from 'react-router-dom';
import SceneCard from './SceneCard';
import LoadingSpinner from './LoadingSpinner';
import { formatAgeRange } from '../utils/formatters';
import { getAgeGroupSettings } from '../utils/age-groups';
import './StoryPreview.css';

const StoryPreview = ({ 
  story, 
  loading, 
  onSave, 
  onRegenerate, 
  onRegenerateScene,
  saved = false 
}) => {
  const navigate = useNavigate();
  
  // If loading, show spinner
  if (loading) {
    return (
      <div className="story-preview-container">
        <LoadingSpinner message="Creating your magical tale..." />
      </div>
    );
  }

  // If no story, show empty state
  if (!story) {
    return (
      <div className="story-preview-container empty">
        <div className="story-preview-empty">
          <span className="story-preview-icon">✨</span>
          <h3>Your magical story will appear here</h3>
          <p>Fill in the details and click "Generate Story" to begin</p>
        </div>
      </div>
    );
  }

  // Get age group display info
  const ageGroup = story.ageGroup ? getAgeGroupSettings(story.ageGroup) : null;
  const ageRangeDisplay = ageGroup ? formatAgeRange(ageGroup.ageRange) : '';

  // View full story
  const handleViewFullStory = () => {
    if (story.id) {
      navigate(`/story/${story.id}`);
    }
  };

  return (
    <div className="story-preview-container">
      <div className="story-preview-header">
        {ageGroup && (
          <span className="story-age-tag">Ages {ageRangeDisplay}</span>
        )}
        <h2 className="story-title">{story.title}</h2>
        
        {story.moral && (
          <div className="story-moral">
            <strong>Moral:</strong> {story.moral}
          </div>
        )}
      </div>
      
      <div className="story-preview-scenes">
        {story.scenes && story.scenes.map((scene, index) => (
          <SceneCard 
            key={index}
            scene={scene}
            sceneIndex={index}
            onRegenerateScene={onRegenerateScene ? () => onRegenerateScene(index) : null}
          />
        ))}
      </div>
      
      <div className="story-preview-actions">
        {!saved && onSave && (
          <button 
            className="pill-button primary"
            onClick={onSave}
            aria-label="Save story to library"
          >
            💾 Save to Library
          </button>
        )}
        
        {saved && (
          <button 
            className="pill-button primary"
            onClick={handleViewFullStory}
            aria-label="Read full story"
          >
            📖 Read Full Story
          </button>
        )}
        
        {onRegenerate && (
          <button 
            className="pill-button outline"
            onClick={onRegenerate}
            aria-label="Regenerate story"
          >
            🔄 Regenerate Story
          </button>
        )}
      </div>
    </div>
  );
};

export default StoryPreview;
